import { Stack } from "@mui/material";
import React from "react";
import SideBar from "./SideBar";
import Topbar from "./Topbar";
import withAuth from "./withAuth";
import PagePermissionGuard from "./PagePermissionGuard";

function MainLayout({ children }) {
  return (
    <Stack
      direction="column"
      height="100vh"
    >
      {/* SIDEAR */} {/* TOPBAR */}
      <Stack
        display={{
          xs: "flex",
          md: "none",
          lg: "flex",
        }}
        flexShrink={0}
      >
        <Topbar />
      </Stack>
      <Stack
        direction="row"
        width="100%"
        flex={1}
        overflow="hidden"
      >
        <Stack
          sx={{
            flexShrink: 0,
            overflowY: "auto",
            width: { xs: 0, md: "auto" },
          }}
        >
          <SideBar />
        </Stack>

        <Stack
          flex={1}
          sx={{
            p: 2,
            overflowX: "scroll",
          }}
        >
          <PagePermissionGuard>{children}</PagePermissionGuard>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default withAuth(MainLayout);
